// extracted by mini-css-extract-plugin
export default {"settingContainer":"course-settings_settingContainer__XwukF","switch":"course-settings_switch__uA1+B","deleteCourseButton":"course-settings_deleteCourseButton__zp3RC"};